import { type DropdownOption } from '~/_shared/baseComponents/dropdown';
import { type RadioGroupItem } from '~/_shared/baseComponents/radio/radioGroup.component';
import { type TranslationFnc } from '~/_shared/utils/hooks';
import { TooltipPlacement } from '~/_shared/utils/placement.util';
import { QUICK_EDIT_BOUNDARY_COUNT_THRESHOLD } from '~/boundary/editMode/boundaryEditModal/constants';

export enum BoundaryEditAction {
  EditBoundaries = 'EditBoundaries',
  QuickEditBoundaries = 'QuickEditBoundaries',
  CreateNewBoundary = 'CreateNewBoundary'
}

export const getBoundaryEditActionOptions = (
  t: TranslationFnc,
  boundaryCount: number | null,
): ReadonlyArray<DropdownOption<BoundaryEditAction>> => {
  if (!boundaryCount) {
    return [{
      name: t('Create New Territory'),
      value: BoundaryEditAction.CreateNewBoundary,
    }];
  }

  const disableQuickEdit = (boundaryCount > QUICK_EDIT_BOUNDARY_COUNT_THRESHOLD);

  return [
    {
      name: t('Create New Territory'),
      value: BoundaryEditAction.CreateNewBoundary,
    }, {
      name: t('Edit Existing Territories'),
      value: BoundaryEditAction.QuickEditBoundaries,
      tooltipContent: disableQuickEdit ? t('boundaryEdit.batchEdit.disabled.explanation', { threshold: QUICK_EDIT_BOUNDARY_COUNT_THRESHOLD }) : undefined,
      tooltipPlacement: TooltipPlacement.Top,
      isDisabled: disableQuickEdit,
    }, {
      name: t('Edit One Territory (Allow Overlaps)'),
      value: BoundaryEditAction.EditBoundaries,
    },
  ];
};

export enum BoundaryEditManualMethod {
  Selection = 'Selection',
  Draw = 'Draw'
}

export const getBoundaryEditManualMethodOptions = (t: TranslationFnc): ReadonlyArray<DropdownOption<BoundaryEditManualMethod>> => ([{
  name: t('Selection'),
  value: BoundaryEditManualMethod.Selection,
}, {
  name: t('Drawing'),
  value: BoundaryEditManualMethod.Draw,
}]);

export enum BoundaryEditSelectFrom {
  Boundary = 'Boundary',
  Territory = 'Territory'
}

export const getBoundaryEditSelectFromRadioGroupOptions = (
  t: TranslationFnc,
  short: boolean,
): ReadonlyArray<RadioGroupItem<BoundaryEditSelectFrom>> => ([{
  label: short ? t('Boundaries') : t('From Boundaries'),
  value: BoundaryEditSelectFrom.Boundary,
}, {
  label: short ? t('Territories') : t('From Territories'),
  value: BoundaryEditSelectFrom.Territory,
}]);
